import { createContext } from 'react';
import { UiStore } from './ui';

export const StoreContext = createContext<UiStore | null>(null);
